import { render } from "./History.vue?vue&type=template&id=ba0a5d6c&scoped=true"
import script from "./History.vue?vue&type=script&setup=true&lang=js"
export * from "./History.vue?vue&type=script&setup=true&lang=js"

import "./History.vue?vue&type=style&index=0&id=ba0a5d6c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba0a5d6c"],['__file',"src/views/History.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ba0a5d6c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ba0a5d6c', __exports__)) {
    api.reload('ba0a5d6c', __exports__)
  }
  
  module.hot.accept("./History.vue?vue&type=template&id=ba0a5d6c&scoped=true", () => {
    api.rerender('ba0a5d6c', render)
  })

}


export default __exports__